import * as React from 'react';
import { observer } from 'mobx-react';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { SideBar } from '../../organisms/mypage/SideBar';
import './page.module.scss';

export const Pane = observer(({ id = undefined, activeMenu, children }) => {
    return (
        <div styleName="pane" id={id}>
            {GlobalStatesV3.viewport.isDesktop && <SideBar activeMenu={activeMenu} />}
            <div styleName="pane-main">{children}</div>
        </div>
    );
});

export const PaneHeader = ({ children }) => <div styleName="pane-header">{children}</div>;
export const PaneSubHeader = ({ children }) => <div styleName="pane-sub-header">{children}</div>;
